module.exports = __webpack_public_path__ + "img/jo.04ded4db.svg";